import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { ITitleBannerProps } from './TitleBanner.definitions';
import { joinClassnames } from 'helpers/classNames';

/** CSS import */
import Styles from './TitleBanner.module.scss';
import SliderStyles from '../../Organisms/SliderItem/SliderItem.module.scss';

const TitleBanner: React.FC<ITitleBannerProps> = ({
  text,
}: ITitleBannerProps) => {
  return (
    <p
      className={joinClassnames(
        SliderStyles['text-opacity'],
        Styles['text-title'],
      )}
    >
      {text}
    </p>
  );
};

export default TitleBanner;
